import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import img from "../assests/images/learners-voices.jpg";

const quotes = [
  {
    title: "Faster problem sets",
    text: "EzShiksha transformed my study routine. Instant math solutions and concise notes saved me time and boosted my grades.",
    name: "Sarah",
  },
  {
    title: "Support when stuck",
    text: "The guided help feels personal. Tough concepts finally clicked without me bouncing between random tabs all night.",
    name: "Rahul",
  },
  {
    title: "Research without friction",
    text: "Text extraction from images simplified my research. I pull key lines into notes in minutes instead of retyping everything.",
    name: "Maya",
  },
];

const Testimonials = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActive((current) => (current + 1) % quotes.length);
    }, 4000);
    return () => window.clearInterval(timer);
  }, []);

  const quote = quotes[active];

  return (
    <section className="bg-brand-surface py-20">
      <Container>
        <div className="grid items-center gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-12">
          <div className="max-w-[420px] lg:max-w-none">
            <img
              src={img}
              alt="Learners studying together and sharing what works"
              className="block aspect-[4/5] w-full rounded-3xl object-cover object-center shadow-brand"
            />
          </div>

          <div className="min-w-0">
            <p className="section-label">Voices</p>
            <h2 className="mb-6">What learners say</h2>

            <blockquote className="m-0 min-h-[200px] border-0 p-0">
              <h3 className="mb-3.5 text-xl text-brand-forest">{quote.title}</h3>
              <p className="mb-5 text-[1.15rem] leading-relaxed text-brand-forest">
                “{quote.text}”
              </p>
              <cite className="font-display text-[0.95rem] font-semibold not-italic text-brand-teal-dark">
                — {quote.name}
              </cite>
            </blockquote>

            <div className="mt-6 flex items-center gap-2" role="tablist" aria-label="Testimonials">
              {quotes.map((item, index) => (
                <button
                  key={item.name}
                  type="button"
                  role="tab"
                  aria-selected={index === active}
                  aria-label={`Show testimonial from ${item.name}`}
                  onClick={() => setActive(index)}
                  className={`h-2.5 rounded-full transition ${
                    index === active
                      ? "w-7 bg-brand-teal"
                      : "w-2.5 bg-brand-forest/20 hover:bg-brand-teal/50"
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Testimonials;
